import React from 'react'
import { Header, tutorialsHooks } from '.'
import { ButtonStyles, ReportStyles, ReportTableStyles } from './Style'
import { Divider, IconButton, SvgIcon, Switch } from "@mui/material";
import { ReactComponent as ReportIcon } from 'assets/icons/Assessments.svg';
import { ReactComponent as ColumnsIcon } from 'assets/icons/Columns.svg';
import { ReactComponent as ChildIcon } from 'assets/icons/Child.svg';
import { ReactComponent as ChildrenIcon } from 'assets/icons/Children.svg';
import { ReactComponent as GlobusIcon } from 'assets/icons/Globus.svg';
import { ReactComponent as GraphIcon } from 'assets/icons/Graph.svg';
import { ReactComponent as VisibilityIcon } from 'assets/icons/Visibility.svg';
import { thirdly4 } from 'styles/theme';
import { ChevronLeft, Dehaze, Done, FilterList, Notifications, NotificationsNone } from '@mui/icons-material';
import { rating3 } from 'styles/theme';
import { rating4 } from 'styles/theme';
import { rating1 } from 'styles/theme';
import { rating2 } from 'styles/theme';
import { Audio1, Wavesurfer } from 'assets'
import { Img, LightButton, XSSpaceBetween } from 'styles/GlobalStyle';
import { rating5 } from 'styles/theme';

const Reports = () => {
    const title = "דוחות"
    const subTitle = "ככה זה עובד:"

    return (
        <ReportStyles>
            <Header title={title} subTitle={subTitle} />
            <div className='title'>{"רשימת הדוחות"}</div>
            <div className='content'>
                <div>
                    <div className='section'>
                        <ReportTableStyles>
                            <div className='item-button'>
                                <ButtonStyles variant='contained' color="dark">
                                    <SvgIcon sx={{ fontSize: 14 }} component={ReportIcon} inheritViewBox />
                                    {"דוחות"}
                                </ButtonStyles>
                            </div>
                            <div className="report-cards">
                                <div className='item-card'>
                                    <div className="report-card-header">
                                        <div className="report-card-title">
                                            {"מבט מאקרו על מצב התלמידים"}
                                        </div>
                                    </div>
                                    <div className="report-card-content report-rows">
                                        <div className="table-row">
                                            <div className="table-col blurred">שירה לוין</div>
                                            <div className="table-col blurred">לוין</div>
                                            <div className="table-col blurred">332</div>
                                            <div className='table-col'><NotificationsNone color="rating3" /></div>
                                            <div className='table-col' style={{ color: rating3 }}>11</div>
                                            <div className='table-col'><Done color="rating2" /></div>
                                            <div className='table-col' style={{ color: rating2 }}>94%</div>
                                            <div className='table-col' style={{ color: rating1 }}>100%</div>
                                            <div className='table-col audio-col'>
                                                <Img src={Audio1} />
                                            </div>
                                            <div className='row-action'>
                                                <SvgIcon component={VisibilityIcon} inheritViewBox />
                                            </div>
                                        </div>
                                        <Divider sx={{ borderColor: thirdly4 }} />
                                        <div className="table-row">
                                            <div className="table-col blurred">שירה לוין</div>
                                            <div className="table-col blurred">לוין</div>
                                            <div className="table-col blurred">332</div>
                                            <div className='table-col'><NotificationsNone color="rating4" /></div>
                                            <div className='table-col' style={{ color: rating4 }}>13</div>
                                            <div className='table-col'><Done color="rating1" /></div>
                                            <div className='table-col' style={{ color: rating1 }}>94%</div>
                                            <div className='table-col' style={{ color: rating1 }}>100%</div>
                                            <div className='table-col audio-col'>
                                                <Img src={Audio1} />
                                            </div>
                                            <div className='row-action'>
                                                <SvgIcon component={VisibilityIcon} inheritViewBox />
                                            </div>
                                        </div>
                                        <Divider sx={{ borderColor: thirdly4 }} />
                                        <div className="table-row">
                                            <div className="table-col blurred">שירה לוין</div>
                                            <div className="table-col blurred">לוין</div>
                                            <div className="table-col blurred">332</div>
                                            <div className='table-col'><Done color="rating1" /></div>
                                            <div className='table-col' style={{ color: rating1 }}>14</div>
                                            <div className='table-col'><Done color="rating1" /></div>
                                            <div className='table-col' style={{ color: rating2 }}>94%</div>
                                            <div className='table-col' style={{ color: rating2 }}>100%</div>
                                            <div className='table-col audio-col'>
                                                <Img src={Audio1} />
                                            </div>
                                            <div className='row-action'>
                                                <SvgIcon component={VisibilityIcon} inheritViewBox />
                                            </div>
                                        </div>
                                        <div className='wrap-circle-border'>
                                            <div className='circle-border eye-circle-border' />
                                        </div>
                                        <div className='open-report-button'>
                                            <LightButton label='פתיחת הדו"ח המפורט' />
                                        </div>
                                    </div>
                                </div>
                                <div className='item-card filter-list-feature'>
                                    <div className="report-card-header">
                                        <div className="report-card-title">
                                            {"הצגה והסתרה של עמודות"}
                                        </div>
                                        <IconButton>
                                            <FilterList />
                                        </IconButton>
                                    </div>
                                    <div className='wrap-filter-list'>
                                        <div className='filter-list'>
                                            <Switch />
                                            <Switch defaultChecked color="secondary" />
                                            <Switch defaultChecked color="secondary" />
                                        </div>
                                    </div>
                                    <div className="report-card-content report-rows">
                                        <div className="table-row">
                                            <div className="table-col blurred">שירה לוין</div>
                                            <div className="table-col blurred">לוין</div>
                                            <div className="table-col blurred">332</div>
                                            <div className='table-col blurred'><NotificationsNone color="rating3" /></div>
                                            <div className='table-col blurred' style={{ color: rating3 }}>11</div>
                                            <div className='table-col blurred'><Done color="rating2" /></div>
                                            <div className='table-col blurred' style={{ color: rating2 }}>94%</div>
                                            <div className='table-col blurred' style={{ color: rating1 }}>100%</div>
                                        </div>
                                        <Divider sx={{ borderColor: thirdly4 }} />
                                        <div className="table-row">
                                            <div className="table-col blurred">שירה לוין</div>
                                            <div className="table-col blurred">לוין</div>
                                            <div className="table-col blurred">332</div>
                                            <div className='table-col blurred'><NotificationsNone color="rating4" /></div>
                                            <div className='table-col blurred' style={{ color: rating4 }}>13</div>
                                            <div className='table-col blurred'><Done color="rating1" /></div>
                                            <div className='table-col blurred' style={{ color: rating1 }}>94%</div>
                                            <div className='table-col blurred' style={{ color: rating1 }}>100%</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ReportTableStyles>
                    </div>
                </div>
                <div>
                    <div className='title'>{"דו”ח אישי מפורט"}</div>
                    <div className='section'>
                        <ReportTableStyles>
                            <div className="report-cards">
                                <div className='item-card'>
                                    <div className="report-card-header">
                                        <div className="report-card-title">
                                            {"פתיחת הדו”ח המפורט"}
                                        </div>
                                    </div>
                                    <div className="report-card-content report-rows">
                                        <div className="table-row">
                                            <div className="table-col blurred">שירה לוין</div>
                                            <div className="table-col blurred">לוין</div>
                                            <div className="table-col blurred">332</div>
                                            <div className='table-col'><NotificationsNone color="rating3" /></div>
                                            <div className='table-col' style={{ color: rating3 }}>11</div>
                                            <div className='table-col'><Done color="rating2" /></div>
                                            <div className='table-col' style={{ color: rating2 }}>94%</div>
                                            <div className='table-col' style={{ color: rating1 }}>100%</div>
                                            <div className='table-col audio-col'>
                                                <Img src={Audio1} />
                                            </div>
                                            <div className='row-action'>
                                                <SvgIcon component={VisibilityIcon} inheritViewBox />
                                            </div>
                                        </div>
                                        <div className='wrap-circle-border'>
                                            <div className='circle-border eye-circle-border' />
                                        </div>
                                    </div>
                                </div>
                                <div className='item-card'>
                                    <div className="report-card-header">
                                        <div className="report-card-title">
                                            {"שמיעת האבחון"}
                                        </div>
                                    </div>
                                    <div className='audio-card'>
                                        <Img src={Wavesurfer} />
                                    </div>
                                </div>
                                <div className='wrap-measurement-data'>
                                    <div className='measurement-data'>
                                        <IconButton>
                                            <Dehaze color="black" />
                                        </IconButton>
                                        <div className='measurement-data-text'>
                                            <div>
                                                תצוגת טקסט
                                            </div>
                                            <div>
                                                נתוני מדידות
                                            </div>
                                        </div>
                                    </div>
                                    <div className='item-card'>
                                        <div className="report-card-header">
                                            <div className="report-card-title">
                                                {"סרגל מצב התלמיד"}
                                            </div>
                                        </div>
                                        <div className='wrap-report-data'>
                                            <div className='report-data'>
                                                <div className='rate-and-accuracy'>קצב</div>
                                                <div>מילים לדקה</div>
                                                <div className='rate-and-accuracy-result'>60 מילים - מהיר</div>
                                            </div>
                                            <div className='report-actions'>
                                                <div className='report-actions bold-report-actions'>
                                                    <div className='bold-report-action'>
                                                        <SvgIcon fontSize='small' component={ChildIcon} inheritViewBox />
                                                        {"תוצאה"}
                                                    </div>
                                                    <div className='bold-report-action'>
                                                        <SvgIcon fontSize='small' component={ChildrenIcon} inheritViewBox />
                                                        {"ביחס לבני כיתתו"}
                                                    </div>
                                                    <div className='bold-report-action'>
                                                        <SvgIcon fontSize='small' component={GlobusIcon} inheritViewBox />
                                                        {"ביחס לשכבת הגיל  "}
                                                    </div>
                                                </div>
                                                <SvgIcon fontSize='small' component={GraphIcon} inheritViewBox />
                                            </div>
                                        </div>
                                        <Divider />
                                        <div className='wrap-report-data'>
                                            <div className='report-data'>
                                                <div className='rate-and-accuracy'>דיוק</div>
                                                <div>אחוז דיוק</div>
                                                <div className='rate-and-accuracy-result'>98%</div>
                                            </div>
                                            <div className='report-actions'>
                                                <div className='report-actions'>
                                                    <SvgIcon fontSize='small' component={ChildIcon} inheritViewBox />
                                                    <SvgIcon fontSize='small' component={ChildrenIcon} inheritViewBox />
                                                    <SvgIcon fontSize='small' component={GlobusIcon} inheritViewBox />
                                                </div>
                                                <div className='report-actions bold-report-actions'>
                                                    <div className='bold-report-action'>
                                                        <SvgIcon fontSize='small' component={GraphIcon} inheritViewBox />
                                                        {"גרף התקדמות אישי"}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='wrap-measurement-data'>
                                    <div className='measurement-data'>
                                        <IconButton>
                                            <Dehaze color="black" />
                                        </IconButton>
                                        <div className='measurement-data-text'>
                                            {"דוח חזותי"}
                                        </div>
                                    </div>
                                    <div className='item-card'>
                                        <div className="report-card-header">
                                            <div className="report-card-title">
                                                {"מקרא השגיאות המסומנות על האבחון"}
                                            </div>
                                        </div>
                                        <div className='rating-list'>
                                            <LightButton direction="rtl" label="מקרא שגיאות" icon={<ChevronLeft />} />
                                            <XSSpaceBetween />
                                            {[rating1, rating2, rating3, rating4, rating5].map((rating) =>
                                                <div className='rating-item' style={{ borderColor: rating }} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ReportTableStyles>
                    </div>
                </div>
            </div>
        </ReportStyles>
    )
}

export default Reports